module.exports = " <div _v-3a843fd0=\"\"> d {{msg}} xcxc fdfa </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-3a843fd0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 415
// module chunks = 0